import React from 'react';
import { connect } from 'react-redux';
import { Jumbotron, Container, Spinner } from 'react-bootstrap';
import moment from 'moment';

//UTILS
import { setEvento } from '../../../../utils/eventosession';

//ACTIONS
import { eventos } from '../../../../actions/eventos/eventos';
import { pesquisa as pesquisatraducoes } from '../../../../actions/traducoes/traducoes';
import { pesquisaCodigoPromocional } from '../../../../actions/produto/codigoPromocional';
import { pesquisaPedidosItens } from '../../../../actions/produto/pedidosItens';
import { item } from '../../../../actions/produto/item';

//COMPONENTS
import CompNavbar from '../../components/CompNavbar';
import CompRodape from '../../components/CompRodape';
import CompHeader from '../../components/CompHeader';
import MultiStepStore from '../../components/productStore/MultiStepStore';
//import "../../styles/global.scss";

class ProductStore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: {
        user: {},
        promotionalCode: {},
        products: []
      },
      language: "",
      store: {
        products: []
      }
    }
    localStorage.setItem('idpromotora', (new URLSearchParams(this.props.location.search)).get('idpromotora'));
    localStorage.setItem('idevento', (new URLSearchParams(this.props.location.search)).get('idevento'));
  }
  async componentDidMount() {
    const dados_basico_evento = {
      idpromotora: localStorage.getItem('idpromotora'),
      idevento: localStorage.getItem('idevento')
    }
    await this.props.pesquisatraducoes(
      {
        ...dados_basico_evento,
        wherein: JSON.stringify({
          campo: 'identificador',
          valores: ['conf_cadastro4']
        })
      }
    );
    const event = await this.props.eventos({ ...dados_basico_evento });
    setEvento(event);
    const products = await this.props.item({ ...dados_basico_evento });
    this.setState({
      store: {
        products: await this.filterStoreProducts(products)
      }
    });
    this.changeLanguage(((new URLSearchParams(this.props.location.search)).get('language') || "PT").toUpperCase());
  }

  changeLanguage = language => {
    localStorage.setItem('language', (language).toUpperCase());
    this.setState({
      language: language
    });
  }

  sortByKey = (array, key) => {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  addProductCart = (idsubitems) => {
    this.setState(state => {
      const itemCart = state.cart.products.find((item) => {
        return item.idsubitems === idsubitems;
      });
      const product = state.store.products.find((item) => {
        return item.idsubitems === idsubitems;
      });
      let products = [];
      if (itemCart) {
        products = state.cart.products.map((item) => {
          if (item.idsubitems === idsubitems) {
            return { ...item, idsubitems, qt: item.qt + 1 };
          } else {
            return item;
          }
        });
      } else {
        products = [...state.cart.products, { idsubitems, qt: product.qtdemin > 0 ? product.qtdemin : 1, multiple: product.multiplaescolha, product }];
      }
      const cart = {
        promotionalCode: state.cart.promotionalCode,
        products
      };
      localStorage.setItem('cart', JSON.stringify(cart));
      return {
        cart, store: {
          products: state.store.products
        }
      };
    });
  }
  removeProductCart = (idsubitems) => {
    const product = this.state.store.products.find((item) => {
      return item.idsubitems === idsubitems;
    });
    this.setState(state => {
      let products = state.cart.products.map((item) => {
        if (item.idsubitems === idsubitems) {
          if (product.qtdemin > 0) {
            return { ...item, idsubitems, qt: item.qt > product.qtdemin ? item.qt - 1 : 0 };
          } else {
            return { ...item, idsubitems, qt: item.qt - 1 };
          }
        } else {
          return item;
        }
      }).filter((item) => {
        if (item.qt > 0) {
          return true;
        } else {
          return false;
        }
      });
      const cart = {
        promotionalCode: state.cart.promotionalCode,
        products
      };
      localStorage.setItem('cart', JSON.stringify(cart));
      return {
        cart, store: {
          products: state.store.products
        }
      };
    });
  }

  addPromotionalCode = async (codigo) => {
    const status = [1, 2, 6];
    await this.props.pesquisaCodigoPromocional({
      idpromotora: localStorage.getItem('idpromotora'),
      idevento: localStorage.getItem('idevento'),
      whereInStatusPedido: JSON.stringify({ ...status }),
      codigo
    });
    let error = "";
    if (Object.keys(this.props.promotionalCode).length > 0) {
      if (moment(this.props.promotionalCode.datalimite).diff(moment(), 'days') < 0) {
        error = "Data expirou.";
      }
      if (this.props.promotionalCode.pedidos_count >= this.props.promotionalCode.qtdmax) {
        error = "Limite de usos atingido.";
      }
    } else {
      error = "Código Promocional inválido.";
    }
    const promCode = this.props.promotionalCode;
    const products = this.state.cart.products;
    let cart = {
      promotionalCode: error ? {} : promCode,
      products: error ? products : []
    };
    if (!error) {
      const store = {
        products: await this.filterStoreProducts(this.props.products,cart)
      };
      if (store.products.length > 0) {
        this.setState({ cart });
        this.setState({ store });
      } else {
        error = "Nenhum produto ativo.";
        cart = {
          promotionalCode: {},
          products: products
        };
      }
    }
    const resp = {
      error,
      cart
    }
    return resp;
  }
  clearCart = async () => {
    const cart = {
      promotionalCode: {},
      products: []
    };
    await this.setState({cart});
    this.setState({
      store: {
        products: await this.filterStoreProducts()
      }
    });
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  filterStoreProducts = async (products = this.props.products, cart = this.state.cart) => {
    let storeProducts = [];
    const promotionalCode = cart.promotionalCode;
    if (products.length > 0) { //evento possui produto?
      storeProducts = products.map((product) => {
        //remover
        if (product.idsubitems == "115") {
          product.multiplaescolha = "N";
        }
        //====
        let productValue;
        let productValueDiscount;
        let productValueSell;

        if (product.tabelaprecos) { //evento possui informações de tabela de preços?
          productValue = product.tabelaprecos.valor;
          productValueDiscount = 0;
          productValueSell = productValue;
          if (moment(product.tabelaprecos.datalimite).diff(moment(), 'days') >= 0) { //produto expirou?
            if (product.tabelaprecos.datainicio) {//produto possui data inicial para venda?
              if (moment(product.tabelaprecos.datainicio).diff(moment()) >= 0) {
                return false;
              }
            }
            if ((Object.keys(promotionalCode)).length !== 0) {//usuario adicionou codigo promocional?
              if (promotionalCode.consideracumulativo === "S") {
                if (promotionalCode.valor !== 0) {
                  productValueDiscount = productValue - promotionalCode.valor;
                }else{
                  productValueDiscount = productValue * ((100 - promotionalCode.percentual) / 100);
                }
              }  
              
              /* 
              if (promotionalCode.valor !== 0) {
                if (promotionalCode.consideracumulativo === "S") {
                  productValueDiscount = productValue - promotionalCode.valor;
                }
              } else {
                productValueDiscount = productValue * ((100 - promotionalCode.percentual) / 100);
              }
               */
              productValueSell = productValueDiscount > 0 ? productValueDiscount : productValue;

              if (promotionalCode.produtosatrelados) {
                let prodAtrelado = promotionalCode.produtosatrelados.find((prod) => {
                  return prod.idsubitems === product.idsubitems;
                });
                if (prodAtrelado !== undefined) {
                  return { ...product, productValue, productValueDiscount, productValueSell };
                }
              } else {
                return { ...product, productValue, productValueDiscount, productValueSell };
              }
            } else {
              if (product.vernocongresso === "S") {
                if (product.tabelaprecos) {
                  return { ...product, productValue, productValueDiscount, productValueSell };
                }
              }
            }
          }
        }
        return false;
      }).filter((product) => {
        return product !== false ? true : false;
      });

      const idsubitems = storeProducts.map((product) => {
        return product.idsubitems;
      });
      const status = [1, 2, 6];
      const orderProducts = await this.props.pesquisaPedidosItens({
        idpromotora: localStorage.getItem('idpromotora'),
        idevento: localStorage.getItem('idevento'),
        whereInStatusPedido: JSON.stringify({ ...status }),
        whereInItens: JSON.stringify({ ...idsubitems })
      });
      storeProducts = storeProducts.map((product) => (
        {
          ...product,
          orderCount: orderProducts[
            orderProducts.findIndex(order =>
              order.idsubitems === product.idsubitems
            )
          ].itenescolhido_count
        }
      ));
    }
    return this.sortByKey(storeProducts, "codigo");
  }
  render() {
    //return this.props.pendingTasks ?
    return false ?
      (
        <div style={{ height: "100vh", lineHeight: "100vh" }} className="text-center">
          <Spinner
            style={{ width: "10rem", height: "10rem" }}
            as="span"
            animation="grow"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <>
          <CompNavbar language={this.state.language} />
          <CompHeader language={this.state.language} />

          <main className="pt-1 pb-5">
            <Container>
              <Jumbotron
                style={{ boxShadow: "0px 10px 8px rgba(0,0,0,0.3)" }}
                className="pt-5 bg-white">
                <MultiStepStore
                  language={this.state.language}
                  store={this.state.store}
                  cart={this.state.cart}
                  addProductCart={this.addProductCart}
                  removeProductCart={this.removeProductCart}
                  addPromotionalCode={this.addPromotionalCode}
                  clearCart={this.clearCart} />
              </Jumbotron>
            </Container>
          </main>

          <CompRodape language={this.state.language} />
        </>
      );
  }
}
const mapStateToProps = (state) => {
  return {
    promotionalCode: state.reducerPesquisaCodigoPromocional[0] ? state.reducerPesquisaCodigoPromocional[0] : state.reducerPesquisaCodigoPromocional,
    trads: state.reducerTraducoes,
    event: state.reducerEventos[0] ? state.reducerEventos[0] : state.reducerEventos,
    products: state.reducerPesquisaSubitem,
    orderProduct: state.pesquisaPedidosItens,
    pendingTasks: state.pendingTasks
  };
}
export default connect(mapStateToProps, {
  pesquisatraducoes,
  pesquisaCodigoPromocional,
  pesquisaPedidosItens,
  eventos,
  item
})(ProductStore);
